import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, timeAgo } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const SourceSuggestions = ({ onAdd, reloadKey }) => {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/source-suggestions").then((r) => setRows(r.data.suggestions)).catch(() => {});
  useEffect(() => { load(); }, [reloadKey]);
  const decline = async (s) => {
    try { await api.post(`/admin/source-suggestions/${s.id}`, { action: "declined" }); toast.success("Suggestion declined. The member has been told."); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!rows.length) return null;
  return (
    <section className="mb-6 space-y-2" data-testid="source-suggestions">
      <h2 className="text-2xl">Suggested by members ({rows.length})</h2>
      {rows.map((s) => (
        <div key={s.id} className="surface flex flex-wrap items-start gap-3 p-4" data-testid={`suggestion-${s.id}`}>
          <div className="min-w-0 flex-1 space-y-0.5">
            <p className="font-medium">{s.name} <a href={/^https?:/i.test(s.url) ? s.url : `https://${s.domain}`} target="_blank" rel="noopener noreferrer" className="ml-1 inline-flex items-center gap-0.5 text-xs text-[hsl(var(--facts))] hover:underline">{s.domain}<ExternalLink size={11} /></a></p>
            {s.reason && <p className="text-sm text-slate-600">"{s.reason}"</p>}
            <p className="text-xs text-slate-400">Suggested by {s.by} · {timeAgo(s.created_at)}</p>
          </div>
          <div className="flex gap-2">
            <Button size="sm" className="rounded-full" onClick={() => onAdd(s)} data-testid={`suggestion-add-${s.id}`}>Review & add</Button>
            <Button size="sm" variant="outline" className="rounded-full" onClick={() => decline(s)} data-testid={`suggestion-decline-${s.id}`}>Decline</Button>
          </div>
        </div>
      ))}
    </section>
  );
};
